import React from "react";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

const Divider = () => (
  <div className="border-right-1 border-300" style={{ height: "40px" }} />
);

const Stat = ({ label, value }) => (
  <div className="flex flex-column align-items-center gap-1">
    <span
      className="text-xs text-500 font-medium"
      style={{ textTransform: "uppercase", letterSpacing: "0.5px" }}
    >
      {label}
    </span>
    <span className="text-2xl font-bold text-900">{value}</span>
  </div>
);

const TransactionsSummary = ({
  totalCostExcludingFee,
  totalCostWithFee,
  totalTransactions,
  totalPaidEnergy,
  totalFreeEnergy,
  clearTransactions,
}) => {
  const handleClearClick = () => {
    confirmDialog({
      message: "Are you sure you want to clear history?",
      header: "Clear History",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: clearTransactions,
    });
  };

  return (
    <div className="flex flex-column align-items-center gap-4 surface-100 border-round-lg p-4">
      <ConfirmDialog />
      <div className="flex align-items-center gap-4 flex-wrap justify-content-center">
        <Stat label="Transactions" value={totalTransactions} />
        <Divider />
        <Stat label="Total (excl. fee)" value={`€${totalCostExcludingFee}`} />
        <Divider />
        <Stat label="Total (incl. fee)" value={`€${totalCostWithFee}`} />
        <Divider />
        <Stat label="Paid Energy" value={`${totalPaidEnergy} kWh`} />
        <Divider />
        <Stat label="Free Energy" value={`${totalFreeEnergy} kWh`} />
      </div>
      <Button
        label="Clear History"
        icon="pi pi-trash"
        severity="danger"
        onClick={handleClearClick}
      />
    </div>
  );
};

export default TransactionsSummary;
